export default __webpack_public_path__ + "static/media/char_head_005.5a56c0a3.png";